import axios from "axios";

const api = axios.create({
   baseURL: "https://us-central1-vercelli-bikes.cloudfunctions.net/app/",
   //baseURL: "http://localhost:4002",
});

export default api;